import api from "../services/api";

/**
 * Service for all invoice-related API operations
 */
const invoiceService = {
  /**
   * Fetches paginated invoices with optional date filters
   */
  async fetchInvoices(page = 1, fromDate = null, toDate = null) {
    let url = `/invoices?page=${page}`;

    if (fromDate && toDate) {
      url += `&from=${fromDate}&to=${toDate}`;
    }

    const response = await api.get(url);
    return response.data;
  },

  /**
   * Fetches all invoices (no pagination)
   */
  async fetchAllInvoices(fromDate = null, toDate = null) {
    let url = `/invoices?all=true`;

    if (fromDate && toDate) {
      url += `&from=${fromDate}&to=${toDate}`;
    }

    const response = await api.get(url);
    return response.data?.data ?? response.data ?? [];
  },

  /**
   * Downloads the PDF of an invoice
   */
  async downloadPdf(invoiceId) {
    const response = await api.get(`/invoices/${invoiceId}/pdf`, {
      responseType: "blob",
    });
    return response.data;
  },
};

export default invoiceService;